export default __webpack_public_path__ + "static/media/new_directory.c90b236f.png";